import store from "@/store";

export default async (to, from, next) => {
  await store.dispatch("setEmailLogs", {
    page: 1,
    perPage: 10
  });
  next();
};
